// extracted by mini-css-extract-plugin
export default {"button":"g2oVzU","orderInformation":"RdklyD","orderNumber":"ItYeSK","placedOn":"UYwli9","tickets":"bS2Qoy","summaryDetails":"Ud7SnW","link":"F2oRKw"};